import PosButton from "@/Components/PosMenu/PosButton";
import useCommon from "@/shared/hooks/useCommon";

const PosSources = ({
  methods,
  active,
  setSource,
}: {
  setSource: (value: number[]) => void;
  active: number[];
  methods: {
    label: string;
    value: number[];
    translationKey: string;
    icon: string;
    fill: string;
    size: string;
  }[];
}) => {
  const t = useCommon();
  return (
    <div className="mb-4 flex h-16 flex-wrap flex-col gap-[0.4rem] md:flex-row">
      <PosButton onClick={() => setSource([-1])} isActive={active.includes(-1)}>
        {t(`all`)}
      </PosButton>

      {methods?.map((source) => (
        <PosButton
          onClick={() => setSource(source.value)}
          isActive={active.some((value) => source.value.includes(value))}
          key={source.value}
        >
          {t(`${source.translationKey}`)}
        </PosButton>
      ))}
    </div>
  );
};

export default PosSources;
